<template>
  <swiper :options="Option" class="my-swiper2" :style="{'height':swiperHeight+'px'}" v-if="bannerList.length">
    <swiper-slide
			class="swiper_slide"
      v-for="(item, index) in bannerList"
      :key="index"
    >
      <div class="rc-main">
				<template v-if="item.url">
					<a :href="item.url">
						<img v-if="item.covers" :src="item.covers"  />
						<img v-else src="@/assets/img/empty.png" >
					</a>
				</template>
				<template v-else>
					<img v-if="item.covers" :src="item.covers"  />
					<img v-else src="@/assets/img/empty.png" >
				</template>
        
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "adve-banner",
  data() {
    return {
      Option: {
        centeredSlides: true,
        // slidesPerView: "auto",
        watchSlidesProgress: true,
        slidesPerView: 1,
        width: 255,
				autoplay: true,
				// loop:true,
      },
			bannerList: [],
			swiperHeight:143,
    };
  },
  components: { Swiper, SwiperSlide },
  computed: {
    clientWidth() {
      return document.body.clientWidth;
    },
  },
  created() {
		console.log(this.clientWidth,'sadsadsads')
		let width = this.clientWidth * 0.8;
		this.Option.width=width;
		this.swiperHeight=(width*9)/16;
		console.log(width,this.swiperHeight,'optin');
    this.init();
  },
  methods: {
    ...mapActions({
      LinkExInvitation: "linkTo/LinkExInvitation",
      getBannerByGraphal: "getBannerByGraphal",
    }),
    async init() {
      this.bannerList = [];
      let listData = await this.getBannerByGraphal("show.page.home.ad.en");
      console.log(listData,'listttt')
      this.$emit("requestOk", "adveIsOk"); //专题直播获取完成
      if (listData.bannerQuery && listData.bannerQuery.by) {
        listData.bannerQuery.by.sort((a,b)=>{return a.showIndex - b.showIndex});
        this.bannerList = listData.bannerQuery.by;
      }
      if (this.bannerList.length > 3) {
        this.bannerList = this.bannerList.slice(0, 3);
      }
      // if (this.bannerList.length > 0) {
      //   let n = Math.abs(this.bannerList.length - 3);
      //   for (let i = 0; i < n; i++) {
      //     this.bannerList.push({ covers: false });
      //   }
      // }
      // console.log(this.bannerList,'首页bannerlist');
    },
  },
};
</script>
 
<style scoped lang="scss">
.my-swiper2 {
  height: 2.85rem;
  min-width: 100%;
	margin: 0.4rem 0;
	.swiper_slide{
		.rc-main{
			width:100%;
			height: 100%;
			padding: 0.2rem;
			transition: all 0.3s;
			overflow: hidden;
			a{
				width: 100%;
				height: 100%;
			}
			img{
				border-radius:0.1rem ;
				box-shadow: 0px 0px 15px 0px 
			rgba(0, 0, 0, 0.1);
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}
		}
		&.swiper-slide-active{
			.rc-main{
				padding: 0;
			}
		}
	}
	
}
.swiper-container {
  font-size: 0;
}
.swiper-slide-active {
  transform: scale(1) !important;
}

</style> 